import $api from '../../utils/api.js'


const state = () => ({
    music: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Music'
    },
    formdata:{
        id:'',
        title:'',
        music_name:'',
        music_size:'',
        music_type:'',
        is_public:'false',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.music = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            title:payload.title,
            music_name:payload.name,
            music_size:payload.size,
            music_type:payload.type,
            is_public:payload.is_public,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            title:'',
            music_name:'',
            music_size:'',
            music_type:'',
            is_public:'false',
        },
        state.errors = []
    },
    CLEAR_MUSIC(state){
        state.music = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getMusic({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`music?page=${state.music.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createMusic({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`music`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateMusic({ state,commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`music/${state.formdata.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteMusic({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`music/${payload}`)
            .then(() => {
                dispatch('getMusic').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}